<template lang="pug">
	div.text-center
		h1 В разработке
		h1 Coming soon...
</template>

<script>
export default {
	name: "examples",
}
</script>
